module.exports = __webpack_public_path__ + "static/media/timur-dzhambinov.e8e83d37.jpg";